import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import displayName from 'component-lib/displayName';

import RetinaImage from '../../RetinaImage';
import TextLabel from '../Labels/TextLabel';

import searchIconImage from './images/search-dark-gray.png';
import closeIconImage from './images/close-gray.png';

import styles from './SearchField.scss';

const ANIMATION_DURATION = 200;

export default class SearchField extends Component {
    static displayName = displayName('Widgets/SearchField');

    static propTypes = {
        searchText: PropTypes.string,
        placeholder: PropTypes.string,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        searchText: '',
        placeholder: '',
    };

    constructor(props) {
        super(props);

        this.state = { isSearchOpened: false };
    }

    onSearch = ({ target: { value } }) => {
        const { onChange } = this.props;

        onChange(value, true);
    };

    toggleSearchField = () => {
        const { onChange } = this.props;
        const { isSearchOpened } = this.state;

        // TODO: remove dependency on findDOMNode
        /* eslint-disable react/no-find-dom-node */
        const $initialView = $(findDOMNode(this.initialView));
        const $initialText = $(findDOMNode(this.initialText));
        const $searchWrapper = $(findDOMNode(this.searchInputWrapper));
        const $searchInput = $(findDOMNode(this.searchInput));
        const iconWidth = $initialView.width();
        const parentWidth = $initialView.parent().width();
        const newPosition = isSearchOpened ? '0' : `${parentWidth - iconWidth - 8}px`;
        const newSearchWrapperSize = isSearchOpened ? '0' : '100%';
        const newSearchInputOpacity = isSearchOpened ? '0' : '1';
        const initialTextOpacity = isSearchOpened ? '1' : '0';
        /* eslint-enable react/no-find-dom-node */

        $searchInput.animate({
            opacity: newSearchInputOpacity,
        }, ANIMATION_DURATION);

        $initialView.animate({
            right: newPosition,
        }, ANIMATION_DURATION);

        $searchWrapper.animate({
            width: newSearchWrapperSize,
        }, ANIMATION_DURATION);

        $initialText.animate({
            opacity: initialTextOpacity,
        }, ANIMATION_DURATION);

        $searchInput.focus();

        this.setState({
            isSearchOpened: !isSearchOpened,
        });

        onChange('', !isSearchOpened);
    };

    render() {
        const { placeholder, value, searchText } = this.props;

        return (
            <div
                className={styles['search-wrapper']}
                data-field="search-field"
            >
                <div
                    ref={(c) => { this.initialView = c; }}
                    role="presentation"
                    className={styles['initial-view']}
                    data-action="search-field"
                    onClick={this.toggleSearchField}
                >
                    <RetinaImage
                        data-action="open-search"
                        image={searchIconImage}
                        className={styles['search-icon']}
                    />
                    {
                        searchText &&
                        <TextLabel
                            ref={(c) => { this.initialText = c; }}
                            className={styles['initial-text']}
                        >
                            {searchText}
                        </TextLabel>
                    }
                    {!searchText && <TextLabel className={styles['initial-text-zero']}>
&nbsp;
                    </TextLabel>}
                </div>

                <div
                    ref={(c) => { this.searchInputWrapper = c; }}
                    className={`search-input-wrapper ${styles['search-input-wrapper']}`}
                >
                    <input
                        ref={(c) => { this.searchInput = c; }}
                        data-field="search-input"
                        className={styles['search-input']}
                        placeholder={placeholder}
                        value={value}
                        onChange={this.onSearch}
                        type="text"
                    />
                    <RetinaImage
                        onClick={this.toggleSearchField}
                        data-action="close-search"
                        image={closeIconImage}
                        className={styles['close-icon']}
                    />
                </div>
            </div>
        );
    }
}
